import { useMutation } from '@tanstack/react-query';
import { convertTimeToMinutes } from '~/components/Request/multiday/utils';
import { UserProfession } from '~/enums/UserProfession';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

export interface IEditOpenShiftMutationPayload {
  localDate: string;
  arrivalTime: string;
  departureTime: string;
  mealBreakDuration: string;
  isMealBreakPaid: boolean;
  rate: number | null;
  procedures: string[];
  isAssistedHygiene?: boolean;
  autoConfirmFavorites: boolean;
  autoConfirmEligible: boolean;
}

interface IUseEditOpenShiftMutationParams {
  jobId: string;
  professionCode: string;
  onSuccess: () => void;
}

export const buildJobData = (payload: IEditOpenShiftMutationPayload, professionCode: string) => ({
  localDate: payload.localDate,
  localStart: payload.arrivalTime,
  localEnd: payload.departureTime,
  rate: payload.rate,
  lunch_break_time: convertTimeToMinutes(payload.mealBreakDuration),
  is_lunch_break_paid: payload.isMealBreakPaid,
  procedures: payload.procedures,
  ...(professionCode === UserProfession.RDH && {
    isAssistedHygiene: payload.isAssistedHygiene,
  }),
  autoFill: payload.autoConfirmEligible,
  autofillOptions: {
    favorite: payload.autoConfirmFavorites,
  },
});

export const useEditOpenShiftMutation = ({
  jobId,
  professionCode,
  onSuccess,
}: IUseEditOpenShiftMutationParams) => {
  return useMutation({
    mutationFn: async (payload: IEditOpenShiftMutationPayload) => {
      const jobData = buildJobData(payload, professionCode);
      const headers = await getAuthHeaders();
      return tempMeeApi.patch(`/jobs/${jobId}`, jobData, { headers });
    },
    onSuccess,
  });
};
